// Unexpected errors in the admin panel are sent to the backend (/client-errors),
// which logs them and forwards them to Sentry when configured.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const MAX_REPORTS_PER_PAGE = 10;
let sent = 0;

export function reportClientError(error, context = {}) {
  if (!BACKEND_URL || sent >= MAX_REPORTS_PER_PAGE) return;
  sent += 1;
  const err = error instanceof Error ? error : new Error(String(error?.message || error));
  fetch(`${BACKEND_URL}/api/client-errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify({
      source: window.location.hostname.startsWith('admin.') ? 'admin' : 'web',
      message: err.message.slice(0, 2000),
      stack: err.stack?.slice(0, 8000),
      context: { url: window.location.pathname, ...context },
    }),
  }).catch(() => {});
}

export function installGlobalErrorHandler() {
  window.addEventListener('error', (event) => reportClientError(event.error || event.message));
  window.addEventListener('unhandledrejection', (event) => reportClientError(event.reason, { unhandledRejection: true }));
}
